export function authHeader() {
    // return authorization header with basic auth credentials
    let token = JSON.parse(localStorage.getItem('token'));

    if (token && token.token_type && token.access_token) {
        return { 'AppAuthorization': token.token_type + ' ' + token.access_token };
    } else {
        return {};
    }
}